import { useForm } from "react-hook-form";

import { useEffect } from "react";
import styles from "./LemmasFileForm.module.css";

export default function LemmasFileForm({
  lemmaFileInformation,
  formId,
  setFormData,
  setIsSubmitting,
}) {
  const {
    register,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm({
    defaultValues: {
      file_label: lemmaFileInformation ? lemmaFileInformation.name : "",
      is_certified: lemmaFileInformation
        ? lemmaFileInformation.is_certified
        : false,
    },
  });

  useEffect(() => {
    setIsSubmitting(isSubmitting);
  }, [isSubmitting]);

  const onSubmit = (data) => {
    if (!lemmaFileInformation) {
      // It's about a creation
      const file = data.file_content[0];
      const submittedData = {
        file_label: data.file_label,
        file_content: file,
        file_extension: file.name.split(".").pop().toLowerCase(),
        is_certified: data.is_certified,
      };
      setFormData(submittedData);
    } else {
      // It's about an update
      setFormData(data);
    }
  };

  return (
    <form
      id={formId}
      onSubmit={handleSubmit(onSubmit)}
      className={styles.container}
    >
      <div className={styles["field-container"]}>
        <label className={styles.label}>Label du fichier</label>
        <input
          {...register("file_label", {
            required: true,
            validate: (value) => {
              return !!value.trim();
            },
          })}
          type="text"
          required={true}
          disabled={isSubmitting}
          className={styles["text-input"]}
          placeholder="Saisir le label du fichier"
        />
      </div>
      <div className={styles["checkbox-container"]}>
        <label className={styles.label}>Le fichier est-il certifié ?</label>
        <input
          {...register("is_certified")}
          type="checkbox"
          disabled={isSubmitting}
          className={styles["checkbox-input"]}
        />
      </div>
      {!lemmaFileInformation && (
        <div className={styles["field-container"]} style={{ gap: "10px" }}>
          <span className={styles.label}>
            Uploader un fichier (seuls les fichiers JSON sont acceptés)
          </span>
          <label
            htmlFor="file-input"
            className={styles["file-input-container"]}
          >
            <input
              id="file-input"
              {...register("file_content", {
                required: true,
              })}
              className={styles["file-input"]}
              type="file"
              accept=".json,.jsonl"
            />
          </label>
        </div>
      )}
    </form>
  );
}
